var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('p',{staticClass:"has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.section.standard.name)+" ")]),_c('p',{staticClass:"has-text-grey"},[_vm._v(_vm._s(_vm.section.title))])]),_c('td',[_vm._v(_vm._s(_vm.section.setting.secure_setting))]),_c('td',[_c('span',{class:{
       'has-text-success': _vm.outcome === 'Pass',
       'has-text-danger': _vm.outcome === 'Fail',
     }},[_vm._v(_vm._s(_vm.outcome))])])])}
var staticRenderFns = []

export { render, staticRenderFns }